import { ON_CANCEL_GAME } from '../state-constants/stateConstants';

export const onCancelGame = (viewing) => ({
  type: ON_CANCEL_GAME,
  payload: viewing,
});



// WEBPACK FOOTER //
// ./src/state-actions/onCancelGame.js